import { TradingCheckbox, TradingChip } from '@trading-ui/core';
import { BinIcon } from '@trading-ui/icons';

import i18n from '@/i18n/config';

import type { Company, Plant, User } from '@/interfaces/app.interfaces';

enum CompanyType {
  CONSUMER = 'CONSUMER',
  PRODUCER = 'PRODUCER',
}

type Props = {
  handleDeleteCompany: (companyId: number) => void;
};

export function getCompanyColumns({ handleDeleteCompany }: Props) {
  return [
    {
      Header: i18n.t('settings.moeveActionsTab.activeCompanies.columns.company'),
      accessor: 'name',
      width: 100,
      cellStyle: () => ({ backgroundColor: 'rgba(4, 120, 178, 0.2)', color: '#0478B2' }),
    },
    {
      Header: i18n.t('settings.moeveActionsTab.activeCompanies.columns.cups'),
      accessor: 'cups',
      width: 200,
      Cell: ({ row }: { row: { original: Company } }) => (
        <div>
          {row.original.plants.map((plant: Plant) => (
            <div key={plant.identifier}>{plant.identifier}</div>
          ))}
        </div>
      ),
    },
    {
      Header: i18n.t('settings.moeveActionsTab.activeCompanies.columns.alias'),
      accessor: 'alias',
      width: 200,
      Cell: ({ row }: { row: { original: Company } }) => (
        <div>
          {row.original.plants.map((plant: Plant) => (
            <div key={plant.alias}>{plant.alias}</div>
          ))}
        </div>
      ),
    },
    {
      Header: i18n.t('settings.moeveActionsTab.activeCompanies.columns.associatedTo'),
      accessor: 'associatedTo',
      width: 200,
      Cell: ({ row }: { row: { original: Company } }) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
          {row.original.users.map((user: User) => (
            <TradingChip key={user.id} label={user.name} />
          ))}
        </div>
      ),
    },
    {
      Header: i18n.t('settings.moeveActionsTab.activeCompanies.columns.consumer'),
      accessor: 'consumer',
      width: 100,
      cellStyle: () => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }),
      headerStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      Cell: ({ row }: { row: { original: Company } }) => (
        <TradingCheckbox
          checked={row.original.companyType.code === CompanyType.CONSUMER}
          onChange={() => {}}
          style={{ margin: '0 auto' }}
          disabled
        />
      ),
    },
    {
      Header: i18n.t('settings.moeveActionsTab.activeCompanies.columns.producer'),
      accessor: 'producer',
      width: 100,
      headerStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      cellStyle: () => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }),
      Cell: ({ row }: { row: { original: Company } }) => (
        <TradingCheckbox
          checked={row.original.companyType.code === CompanyType.PRODUCER}
          onChange={() => {}}
          style={{ margin: '0 auto' }}
          disabled
        />
      ),
    },
    {
      Header: '',
      accessor: 'delete',
      width: 40,
      cellStyle: () => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        cursor: 'pointer',
        backgroundColor: 'rgba(4, 120, 178, 0.2)',
        color: '#0478B2',
      }),
      Cell: ({ row }: { row: { original: Company } }) => (
        <BinIcon size={24} className="icon-hover" onClick={() => handleDeleteCompany(row.original.id)} />
      ),
    },
  ];
}